/**
 * The brand's site frames Link your site membership (/plus/site) on its Plus page (decision 212). That
 * is the one screen the app allows a frame for (the API's frame-ancestors, lib/csp.ts): anywhere else it
 * lands inside a frame, it hands the visit to the top window, so nothing of the app is ever clickjacked.
 * The session cookie is SameSite=Lax and never travels into a cross-site frame, so a framed visit is
 * signed out; it offers to continue in the app instead of asking anyone to sign in inside a frame.
 */
/** The same test the API's frame-ancestors uses (lib/csp.ts). */
export const isFramedPath = (path: string) => /^\/plus\/site(?:[?#]|$)/.test(path)

export const framed = (() => {
  try {
    return window.self !== window.top
  } catch {
    return true
  }
})()

/** Leave the frame: the top window opens `path` on this origin (a cross-origin top may be navigated, not read). */
export function openTop(path: string): void {
  const url = `${window.location.origin}${path}`
  try {
    if (window.top) window.top.location.href = url
    else window.location.href = url
  } catch {
    window.location.href = url
  }
}
